import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";



const MyDataCheckSection = () => {
  const { t } = useTranslation();
  const questions = [
  t("question1"),
  t("question2"),
  t("question3"),
  t("question4"),

];
  return (
    <section className="bg-white dark:bg-[#706F6F] py-20 px-6 md:px-20">
      {/* Titre principal */}
      <motion.h2
        className="text-4xl md:text-4xl font-serif font-bold text-center mb-16 text-green-500"
        initial={{ opacity: 0, y: -40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
         {t("mydataCheck.title")}<span className="text-green-500">MyDataCheck</span> ❓
      </motion.h2>

      {/* Grille de cartes */}
      <div className="flex flex-wrap gap-8 max-w-6xl mx-auto">
        {questions.map((q, index) => (
          <motion.div
            key={index}
            className="bg-white text-black p-6 rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.1 }}
            viewport={{ once: true }}
          >
            <p className="text-lg leading-relaxed">“{q}”</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default MyDataCheckSection;
